"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var QueriesStore_1 = require("../../../../stores/QueriesStore");
var HomeQueryTypeFilter = function (_a) {
    var currentQueryType = _a.currentQueryType, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "home-user-filter flex flex-row" },
        react_1.default.createElement(Select_1.default, { name: "query-type-filter", value: currentQueryType, onChange: onChange, options: Object.keys(QueriesStore_1.QueryTypesText).filter(function (key) { return isNaN(parseInt(key)); })
                .map(function (key) { return ({
                value: QueriesStore_1.QueryTypesText[key],
                text: QueriesStore_1.QueryTypesText[key]
            }); }) })));
};
exports.default = HomeQueryTypeFilter;
